import React from 'react'
import { Link } from 'react-router-dom'
import { cn } from '../../lib/utils'
import { pagePanel } from '../layout/page-styles'
import type { LucideIcon } from 'lucide-react'

export type IconActionButtonProps = {
  icon: LucideIcon
  label: string
  to?: string
  onClick?: () => void
  className?: string
  disabled?: boolean
  hint?: string
}

export const IconActionButton: React.FC<IconActionButtonProps> = ({
  icon: Icon,
  label,
  to,
  onClick,
  className,
  disabled,
  hint,
}) => {
  const shared = cn(
    pagePanel,
    'group relative flex flex-col items-center justify-center gap-2.5 hover:bg-surface-card-hover transition-colors duration-150 p-5 w-36 h-36 text-center select-none',
    disabled && 'opacity-40 pointer-events-none',
    className
  )

  const content = (
    <>
      <div className="flex items-center justify-center rounded-xl bg-primary-50 w-12 h-12 ring-1 ring-primary-100">
        <Icon className="w-6 h-6 text-primary-600" strokeWidth={1.8} />
      </div>
      <span className="text-sm font-medium text-neutral-700 group-hover:text-primary-700 transition-colors">
        {label}
      </span>
      {disabled && hint ? (
        <span className="text-[10px] leading-tight text-error-500 font-medium -mt-1">{hint}</span>
      ) : null}
    </>
  )

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={shared} aria-label={label}>
        {content}
      </Link>
    )
  }
  return (
    <button type="button" onClick={onClick} className={shared} aria-label={label} disabled={disabled}>
      {content}
    </button>
  )
}
